import { CloseIcon } from 'assets/icons/CloseIcon'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { Modal } from 'components/Modal/Modal'
import { generateRecords } from 'features/food/foodSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const GenerateFoodRecordsModal = ({ closeModal, }: { closeModal: any }) => {
    const [date, setDate] = useState(new Date())
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        const resp = await dispatch(generateRecords(date))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >Generate Records</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <CalendarInput defaultValue={date} onChange={(d) => setDate(d)} labelText='Date' />
            </Flex>
            <Button mt='16' orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

